import { HeadlineVariation } from '@allesauto/utils/consts';
import { sbEditable } from '@storyblok/storyblok-editable';
import clsx from 'clsx';
import React, { FC } from 'react';

import Headline from '../headline';

export interface TitleStageProps {
  title: string;
  component: string;
  _uid: string;
  _editable?: string;
}

const TitleStage: FC<TitleStageProps> = (props) => {
  const { title } = props;

  const className = {
    container: clsx(
      'bg-purple80 monochrome:bg-black',
      'grid grid-cols-24 py-30px lg:py-80px'
    ),
    headline: 'sm:col-end-24 sm:col-start-2 text-headline1 break-words',
  };

  return (
    <div {...sbEditable(props)} className={className.container}>
      <Headline
        headlineTag={HeadlineVariation.H1}
        headlineText={title}
        headlineColor="text-white"
        headlineClassName={className.headline}
      />
    </div>
  );
};

export default TitleStage;
